export interface IParseImagesItem {
  /** Полное HTML-тело шаблона */
  outerHtml: string;
}

export interface IParseImage {
  /** HTML-контент */
  html: string;
  /** Коллекция блоков */
  items: IParseImagesItem[];
}

/**
 * Парсит и вырезает тэги img
 */
export const parseImages = (
  html: string,
  replaceCallback?: (item: IParseImagesItem, index: number) => string,
): IParseImage => {
  const imgPattern = '<img[^>]*?/?>';
  const linkedImgPattern = `<a[^>]*?>[^<]*?${imgPattern}[^<]*?</a>`;
  const pattern = new RegExp(`(${linkedImgPattern})|(${imgPattern})`, 'gis');
  const items: IParseImagesItem[] = [];
  let match;

  if (!html) {
    return {
      html: '',
      items,
    };
  }

  let index = 0;
  while ((match = pattern.exec(html))) {
    index = html.indexOf(match[0], index);
    const outerHtml = match[0];

    if (outerHtml) {
      items.push({
        outerHtml,
      });
    }
  }

  return {
    html: replaceCallback
      ? items.reduce((acc, item, index) => acc.replace(item.outerHtml, replaceCallback(item, index)), html)
      : html,
    items,
  };
};
